<template>
  <div class="voucher-card d-flex flex-column col-xs-12 px-0 py-4 mt-4">
    <h5 class="align-self-center text-white">
      {{ $t('UserProfile.VoucherCard.Title') }}
    </h5>
    <div class="d-flex bg-light opacity-75 p-4" />
    <div class="px-3 col-xxs-8">
      <h6 class="mt-4 text-white">
        {{ $t('UserProfile.VoucherCard.EnterVoucherCode') }}
      </h6>
      <b-input
        v-model="giftCode"
        :placeholder="$t('UserProfile.VoucherCard.VoucherPlaceHolder')"
        class="mt-2"
        dir="ltr"
      />
      <b-button
        id="popover-giftCode"
        variant="secondary"
        class="mt-3"
        @click="ValidateGiftCode()"
      >
        {{ $t('UserProfile.VoucherCard.ApplyVoucherButton') }}
      </b-button>
      <b-popover
        ref="popover"
        :show.sync="isCodeValid"
        target="popover-giftCode"
        :placement="popoverDirection"
        triggers="focus"
      >
        <div class="d-flex flex-row justify-content-between">
          <div class="d-flex">
            {{ validationmessage }}
          </div>

          <a
            href="#"
            :class="{'mr-4': this.pageDirection == 'rtl','ml-4':this.pageDirection == 'ltr'}"
            class="border-0 px-2 bg-danger text-white rounded d-flex align-items-center flex-basis-auto"
            @click="hidePopover"
          >
            X
          </a>
        </div>
      </b-popover>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import utility from '@/utilities/utility'

export default {
  name: 'UserProfileNewUserVoucherCard',
  data () {
    return {
      giftCode: '',
      isCodeValid: false,
      popoverDirection: 'left',
      pageDirection: 'rtl',
      validationmessage: this.$t('UserProfile.VoucherCard.GiftCodeDoesNotExist')
    }
  },
  methods: {
    ...mapActions({
      setSubscriptionPlan: 'order/setSubscriptionPlan'
    }),
    ValidateGiftCode () {
      switch (this.giftCode) {
        case 'sub1':
          var subscriptionPlan = this.getSubscriptionPlan('yearly')
          this.setSubscriptionPlan(subscriptionPlan)
          this.$router.push({ path: 'buysubscriptionfactor' })
          break
        case 'sub2':
          var subscriptionPlan = this.getSubscriptionPlan('monthly')
          this.setSubscriptionPlan(subscriptionPlan)
          this.$router.push({ path: 'buysubscriptionfactor' })
          break
        case 'sub3':
          this.validationmessage = this.$t(
            'UserProfile.VoucherCard.GiftCodeIsNotActive'
          )
          this.isCodeValid = true
          break
        default:
          this.validationmessage = this.$t(
            'UserProfile.VoucherCard.GiftCodeDoesNotExist'
          )
          this.isCodeValid = true
          break
      }
    },
    getSubscriptionPlan (type) {
      // switch (type) {
      //   case "yearly":
      //     var model = {
      //       Icon: "/img/ps-top.svg",
      //       Title: "اشتراک سالانه",
      //       Price: 180000,
      //       Description: "",
      //       Discount: 20,
      //       Accent: "success-light",
      //       TextAccent: "success",
      //       Unit: "تومان",
      //       DiscountedPrice: 180000 - (180000 * 20) / 100
      //     };
      //     return model;
      //     break;
      //   case "monthly":
      //     var model = {
      //       Icon: "/img/ps-left.svg",
      //       Title: "اشتراک ماهیانه",
      //       Price: 15000,
      //       Description: "",
      //       Discount: 10,
      //       Accent: "secondary-light",
      //       TextAccent: "secondary",
      //       Unit: "تومان",
      //       DiscountedPrice: 15000 - (15000 * 10) / 100
      //     };
      //     return model;
      //     break;

      //   default:
      //     return null;
      //     break;
      // }
    },
    hidePopover () {
      this.$refs.popover.$emit('close')
    }
  },
  mounted () {
    if (this.pageDirection === 'rtl') {
      this.popoverDirection = 'left'
    }
  }
}
</script>
